// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"HtmlBlock_wrapperComponent__QC32U","title":"HtmlBlock_title__n4VIl"};